import React, { useState, useContext } from 'react';
import { Typography, Box, Grid, Hidden } from '@mui/material';
import CarouselWrapper from '../components/CarouselComponent/CarouselWrapper';
import GlobalContext from '../context/globalContext';
import BtnComponent from '../components/buttonComponent/BtnComponent';
import { Link } from 'react-router-dom';
import CreatePassword from '../components/forgotPassword/CreatePassword';
import ChangePassword from '../components/forgotPassword/ChangePassword';
import PasswordPage from '../components/forgotPassword/PasswordPage';
import SuccessBox from '../components/SuccessBox/SuccessBox';
import { FORGOTE_PASSWORD } from '../shared/Strings';

function ForgotPassword() {
  const { carousel } = useContext(GlobalContext);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [screenNumber, setScreenNumber] = useState(1);
  return (
    <Box>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <Hidden mdDown>
          <Grid item xs={false} sm={false} md={5}>
            <CarouselWrapper carouselConfig={carousel} />
          </Grid>
        </Hidden>
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            background: '#f7f7f7',
          }}>
          <Box
            sx={{
              position: 'absolute',
              right: 0,
              m: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <Typography marginRight={1} data-testid="head">
              {FORGOTE_PASSWORD.HEAD_TO_LOGIN}
            </Typography>
            <BtnComponent
              component={Link}
              to={'/login'}
              size="small"
              title={FORGOTE_PASSWORD.BTN_TEXT_LOGIN}
              data-testid="login"></BtnComponent>
          </Box>
          <Box
            sx={{
              my: 7,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'left',
              overflow: 'hidden',
              minWidth: { xs: '80vw', sm: '60vw', md: '35vw' },
            }}>
            {screenNumber === 1 && (
              <PasswordPage
                setPhoneNumber={setPhoneNumber}
                setScreenNumber={setScreenNumber}
              />
            )}
            {screenNumber === 2 && phoneNumber && (
              <ChangePassword
                phoneNumber={phoneNumber}
                setScreenNumber={setScreenNumber}
              />
            )}
            {screenNumber === 3 && phoneNumber && (
              <CreatePassword
                phoneNumber={phoneNumber}
                setScreenNumber={setScreenNumber}
              />
            )}
            {screenNumber === 4 && (
              <SuccessBox
                text={FORGOTE_PASSWORD.PASS_CHANGED_SUCCESS}
                data-testid="passsucess"
              />
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ForgotPassword;
